<!-- src/components/LoadingOverlay.vue -->

<template>
    <div class="overlay">
      <div class="m-loader mr-4">
        <svg class="m-circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
        </svg>
      </div>
      <h3 class="l-text">Loading...</h3>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoadingOverlay',
  };
  </script>
  
  <style scoped>
  /* Loader overlay styles */

  
  .m-loader {
    width: 50px;
    height: 50px;
    animation: rotate 2s linear infinite;
  }
  
  .m-circular {
    animation: dash 1.5s ease-in-out infinite;
  }
  
  .m-circular .path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    stroke: var(--bs-primary);
    stroke-linecap: round;
  }
  
  .l-text {
    margin-top: 15px;
    font-size: 1.2em;
    color: var(--bs-primary);
  }
  
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
  
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }
  
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }
  </style>
  